import {
  Text,
  GreyGrey70,
  Link,
  Primary13Regular,
  Tooltip,
  Flex
} from '@sequencehq/core-components'
import { Customer } from 'Cube/domain/cube.domain.types'
import { getLogo } from 'lib/integrations/logos'
import { FC } from 'react'

type CustomerLinkedServicesProps = {
  integrationIds: Customer['integrationIds']
}

export const CustomerLinkedServices: FC<CustomerLinkedServicesProps> = ({
  integrationIds
}) => {
  if (!integrationIds || integrationIds.length === 0) {
    return null
  }

  return (
    <>
      <Text {...Primary13Regular} color={GreyGrey70}>
        External links
      </Text>
      <Flex gap={2} overflow="hidden">
        {integrationIds.map(linkedService => (
          <Tooltip
            key={linkedService.service}
            label={linkedService.service.replace(/_/g, ' ')}
            hasArrow
          >
            {linkedService.url ? (
              <Link to={linkedService.url} isExternal>
                {getLogo(linkedService.service, 20)}
              </Link>
            ) : (
              <div>{getLogo(linkedService.service, 20)}</div>
            )}
          </Tooltip>
        ))}
      </Flex>
    </>
  )
}
